import type { State } from '../../types';
import type { EmployeeViewModel } from '@trinnvis/dabih-api-client';

export function getEmployeesById(state: State): { [uuid: string]: EmployeeViewModel } {
  return state.organization !== undefined ? state.organization.employeesById : {};
}
